import { defineInlineEdit } from "../../../../../components/MobileList/inlineEdit";

/**
 * views/jomla/expense/from submits the whole form, which getById fills as
 * `{id, spending_type_id, amount, date, note, safe_id}` — the list row instead
 * carries `spending_type_name`, so the detail is fetched before the PUT.
 *
 * `amount` is not editable: the form renders it `disabled={!isAdd}`.
 */
export default defineInlineEdit({
  api: "jExpense",
  permission: "j_spending_edit",
  hydrate: true,
  toPayload: (detail) => ({
    id: detail.id,
    spending_type_id: detail.spending_type_id ?? detail.spending_type?.id,
    safe_id: detail.safe_id ?? detail.safe?.id,
    amount: detail.amount,
    date: detail.date,
    note: detail.note ?? "",
  }),
  fields: {
    date: { label: "التاريخ", type: "date", required: true },
    note: { label: "الملاحظة", type: "multiline" },
  },
});
